module.exports = __webpack_public_path__ + "media/scholarship_winners/emma-h-8aaa9969.png";